import React, { useEffect, useRef, useState } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import moment from "moment";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import ShadowCard from "../../components/common/ShadowCard";
import FormDatePicker from "../../components/formFields/FormDateField";
import {
  phoneWOValueValidator,
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import { FaEye } from "react-icons/fa6";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { checkAcessRights, formatIndianNumber } from "../../_helper/helper";
import { FaSyncAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import FormTextArea from "../../components/formFields/FormTextArea";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  PAYMENT_STATUS_ARRAY,
} from "../../_contstants/common";
import { BiCheckDouble } from "react-icons/bi";
import { RxCross2 } from "react-icons/rx";
import { PiClockCountdownFill } from "react-icons/pi";
import {
  clearTopupRequestFilter,
  clearTopupRequestID,
  setTopupRequestFilter,
  setTopupRequestID,
} from "./topupRequestSlice";
import {
  deleteTopupRequest,
  getAllTopupRequests,
  updateTopupRequestStatus,
} from "./services/topuprequest.services";
import ExpandableText from "../../components/common/ExpandableText";
import { getAllBankAccounts } from "../bankaccount/services/bankaccount.services";
import { IBankAccount } from "../bankaccount/bankaccountModel";
import FormTextField from "../../components/formFields/FormTextField";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonCreate from "../../components/drawer/ButtonCreate";
import ButtonEdit from "../../components/drawer/ButtonEdit";
import { MdDelete } from "react-icons/md";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const DummyChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  useEffect(() => {
    formRenderProps.onChange("UserID", {
      value: null,
    });
  }, []);

  return null;
};
const TopupRequest: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.topuprequest.loading);
  const TopupRequestFilterDetails = useAppSelector(
    (state) => state.topuprequest.TopupRequestFilterDetails
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const BankAccountList = useAppSelector(
    (state) => state.bankaccount.BankAccountList
  );

  const [initialValue, setInitialValue] = useState<any>({});
  const [formKey, setFormKey] = useState<any>(1);

  useEffect(() => {
    dispatch(getAllBankAccounts());
  }, []);

  useEffect(() => {
    setInitialValue({
      ...TopupRequestFilterDetails,
      FromDate: TopupRequestFilterDetails?.FromDate
        ? moment(TopupRequestFilterDetails?.FromDate, "YYYY-MM-DD").toDate()
        : null,
      ToDate: TopupRequestFilterDetails?.ToDate
        ? moment(TopupRequestFilterDetails?.ToDate, "YYYY-MM-DD").toDate()
        : null,
    });
    setFormKey(formKey + 1);
  }, [TopupRequestFilterDetails]);

  const handleClear = () => {
    dispatch(clearTopupRequestFilter());
    setFormKey(formKey + 1);
    const payload = {
      FromDate: "",
      ToDate: "",
      DepositedBank: "",
      RequestStatus: "",
      Name: "",
      MobileNo: "",
      FromAmount: 0,
      ToAmount: 0,
      Type: "",
      Limit: +pageLimit,
      Skip: +currentPage * +pageLimit,
    };
    dispatch(getAllTopupRequests(payload));
  };

  const handleSubmit = (values: any) => {
    const payload = {
      ...values,
      FromDate: values?.FromDate
        ? moment(values?.FromDate).format("YYYY-MM-DD")
        : "",
      ToDate: values?.ToDate ? moment(values?.ToDate).format("YYYY-MM-DD") : "",
      Limit: +pageLimit,
      Skip: +currentPage * +pageLimit,
    };
    dispatch(
      setTopupRequestFilter({
        ...values,
        FromDate: payload?.FromDate,
        ToDate: payload?.ToDate,
      })
    );
    dispatch(getAllTopupRequests(payload));
  };

  return (
    <>
      <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <ShadowCard>
            <Form
              key={formKey}
              initialValues={initialValue}
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ width: "100%" }}>
                  <GridLayout
                    style={{ marginRight: 40 }}
                    gap={{ rows: 0, cols: 10 }}
                    cols={[
                      { width: "20%" },
                      { width: "20%" },
                      { width: "20%" },
                      { width: "20%" },
                      { width: "20%" },
                    ]}
                  >
                    <GridLayoutItem
                      colSpan={5}
                      style={{
                        paddingBottom: 5,
                        marginBottom: 5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography.h4
                        style={{ marginBottom: 0, marginLeft: "3px" }}
                      >
                        Top-up Request
                      </Typography.h4>
                      <ButtonCreate
                        label="Add Topup Request"
                        drawerName="topuprequestForm"
                        drawerWidth={600}
                      />
                    </GridLayoutItem>

                    <GridLayoutItem>
                      <Field
                        name="FromDate"
                        label="From Date"
                        format="dd/MM/yyyy"
                        component={FormDatePicker}
                        wrapperStyle={{ margin: 0 }}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="ToDate"
                        label="To Date"
                        format="dd/MM/yyyy"
                        wrapperStyle={{ margin: 0 }}
                        minDate={
                          moment(
                            formRenderProps.valueGetter("FromDate")
                          ).toDate() || new Date(1900, 0, 1)
                        }
                        component={FormDatePicker}
                        validator={
                          formRenderProps.valueGetter("FromDate")
                            ? requiredValidator
                            : skipValidator
                        }
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={2}>
                      <Field
                        name="DepositedBank"
                        label="Deposited Bank"
                        placeholder="i.e. HDFC"
                        component={FormSelectionField}
                        wrapperStyle={{ margin: 0 }}
                        options={BankAccountList?.map(
                          (usertype: IBankAccount) => {
                            return {
                              value: `${usertype?.ID}`,
                              label: `${usertype?.BankName} - ${usertype?.AccountNo}`,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="RequestStatus"
                        label="Status"
                        placeholder="i.e. Approved"
                        component={FormSelectionField}
                        wrapperStyle={{ margin: 0 }}
                        options={PAYMENT_STATUS_ARRAY}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={1}>
                      <Field
                        name="FromAmount"
                        label="From Amount"
                        component={FormNumericTextField}
                        placeholder="i.e. 1000"
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={1}>
                      <Field
                        name="ToAmount"
                        label="To Amount"
                        component={FormNumericTextField}
                        placeholder="i.e. 2000"
                        validator={
                          formRenderProps.valueGetter("FromAmount")
                            ? requiredValidator
                            : skipValidator
                        }
                        min={formRenderProps.valueGetter("FromAmount") || 0}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="MobileNo"
                        type="number"
                        max="16"
                        label="Mobile No"
                        placeholder="i.e. 9999999999"
                        validator={phoneWOValueValidator}
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="Name"
                        type="text"
                        label="Name"
                        placeholder="i.e. John"
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      style={{
                        textAlign: "end",
                        marginTop: "36px",
                        marginRight: 10,
                        width: "100%",
                      }}
                    >
                      <ButtonWithLoading
                        label={"View"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        style={{ marginLeft: 10 }}
                        onClick={handleClear}
                      >
                        Clear
                      </Button>
                    </GridLayoutItem>
                    <GridLayoutItem
                      colSpan={5}
                      style={{
                        paddingBottom: 15,
                        marginBottom: 5,
                        borderBottom: "2px dashed darkgray",
                      }}
                    ></GridLayoutItem>
                  </GridLayout>
                  <DummyChangeWatcher formRenderProps={formRenderProps} />
                </FormElement>
              )}
            />
            <TopupRequestGridComponent />
          </ShadowCard>
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const TopupRequestGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const TopupRequestList = useAppSelector(
    (state) => state.topuprequest.TopupRequestList
  );
  const loading = useAppSelector((state) => state.topuprequest.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const TopupRequestFilterDetails: any = useAppSelector(
    (state) => state.topuprequest.TopupRequestFilterDetails
  );
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  useEffect(() => {
    const payload = {
      ...TopupRequestFilterDetails,
      FromDate: TopupRequestFilterDetails?.FromDate
        ? moment(TopupRequestFilterDetails?.FromDate).format("YYYY-MM-DD")
        : null,
      ToDate: TopupRequestFilterDetails?.ToDate
        ? moment(TopupRequestFilterDetails?.ToDate).format("YYYY-MM-DD")
        : null,
      Limit: +pageLimit,
      Skip: +currentPage * +pageLimit,
    };
    dispatch(getAllTopupRequests(payload));
  }, [currentPage, pageLimit]);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyEditCommandCell = (props: any) => {
    const handleView = (ID: number) => {
      navigate("/topuprequest/view", {
        state: {
          ID: ID,
        },
      });
    };
    const handleOpenEditDialog = (ID: number) => {
      dispatch(openDialog("updateTopupRequest"));
      dispatch(setTopupRequestID(ID));
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteTopupRequest"));
      dispatch(setTopupRequestID(ID));
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Update Status"
          onClick={() => handleOpenEditDialog(props.dataItem.ID)}
        >
          <FaSyncAlt
            className="absolute-position"
            style={{ fontSize: "22px" }}
          />
        </IconButton>
        <ButtonEdit
          ID={props.dataItem.ID}
          drawerName="topuprequestForm"
          drawerWidth={600}
        />
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="View"
          themeColor="tertiary"
          onClick={() => handleView(props.dataItem.ID)}
        >
          <FaEye className="absolute-position" style={{ fontSize: "24px" }} />
        </IconButton>
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Delete"
          onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
        >
          <MdDelete
            className="absolute-position"
            style={{ fontSize: "24px" }}
          />
        </IconButton>
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 9 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <UpdateTopupRequestDialog />
      <DeleteTopupRequestDialog />
      <KendoGrid
        className="responsive-table"
        style={{ maxHeight: "calc(100vh - 310px)", marginTop: 10 }}
        filterable={true}
        filter={filter}
        data={filter ? filterBy(TopupRequestList, filter) : TopupRequestList}
        onFilterChange={handleFilterChange}
        onPageChange={pageChange}
        resizable={true}
        skip={currentPage * pageLimit}
        take={pageLimit}
        total={TopupRequestList[0]?.TotalRecord || TopupRequestList?.length}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column field="TransactionDate" title="Request Date" width={120} />
        <Column
          field="Name"
          title="Name"
          width={150}
          cells={{
            data: (props: any) => {
              return <td>{props.dataItem.Name}</td>;
            },
          }}
        />
        <Column field="MobileNo" title="Mobile No" width={110} />
        <Column
          field="Amount"
          title="Amount"
          width={125}
          cells={{
            data: (props: any) => {
              return (
                <td className="text-end fw-bold">
                  {props.dataItem.Amount
                    ? "₹ " + formatIndianNumber(props.dataItem.Amount)
                    : ""}
                </td>
              );
            },
          }}
        />
        <Column field="DepositedBank" title="Deposited Bank" width={150} />
        <Column field="Type" title="Type" width={110} />
        <Column
          field="Remarks"
          title="Remarks"
          width={250}
          cells={{
            data: (props) =>
              props.dataItem.Remarks ? (
                <ExpandableText text={props.dataItem.Remarks} />
              ) : (
                <td></td>
              ),
          }}
        />
        <Column
          field="RequestStatus"
          title="Status"
          width={150}
          cells={{
            data: (props: any) => {
              return (
                <td
                  style={{
                    ...props.style,
                  }}
                >
                  <div
                    style={{
                      padding: "5px 2px",
                      background:
                        props.dataItem.RequestStatus === "Pending"
                          ? "goldenrod"
                          : props.dataItem.RequestStatus === "Rejected"
                          ? "lightcoral"
                          : "#00a34de6",
                      color: "white",
                      borderRadius: "30px",
                      width: "120px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 5,
                    }}
                  >
                    {props.dataItem.RequestStatus === "Pending" ? (
                      <PiClockCountdownFill fontSize={18} />
                    ) : props.dataItem.RequestStatus === "Rejected" ? (
                      <RxCross2 fontSize={18} />
                    ) : (
                      <BiCheckDouble fontSize={18} />
                    )}

                    {props.dataItem.RequestStatus}
                  </div>
                </td>
              );
            },
          }}
        />
        <Column field="CreatedBy" title="Created By" width={150} />
        {(isEditAccess || isDeleteAccess) && (
          <Column
            field="ID"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"170px"}
            filterable={false}
            locked={true}
          />
        )}
      </KendoGrid>
    </>
  );
};

const UpdateTopupRequestDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const TopupRequestID = useAppSelector(
    (state) => state.topuprequest.TopupRequestID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const loading = useAppSelector((state) => state.topuprequest.loading);
  const TopupRequestFilterDetails: any = useAppSelector(
    (state) => state.topuprequest.TopupRequestFilterDetails
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleSubmit = async (values: any) => {
    try {
      const editPayload = {
        ID: TopupRequestID,
        RequestStatus: values?.RequestStatus,
        RequestStatusRemarks: values?.RequestStatusRemarks,
      };
      const response = await dispatch(updateTopupRequestStatus(editPayload));
      if (response?.meta?.requestStatus === "fulfilled") {
        dispatch(closeDialog());
        const payload = {
          ...TopupRequestFilterDetails,
          FromDate: TopupRequestFilterDetails?.FromDate
            ? moment(TopupRequestFilterDetails?.FromDate).format("YYYY-MM-DD")
            : null,
          ToDate: TopupRequestFilterDetails?.ToDate
            ? moment(TopupRequestFilterDetails?.ToDate).format("YYYY-MM-DD")
            : null,
          Limit: +pageLimit,
          Skip: +currentPage * +pageLimit,
        };
        dispatch(getAllTopupRequests(payload));
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {dialogName === "updateTopupRequest" && (
        <AppDialog>
          <>
            {loading && <LoadingPanel gridRef={gridRef} />}
            <Typography.h5 className="m-0">
              {"Update Topup Request Status"}
            </Typography.h5>
            <Form
              onSubmit={handleSubmit}
              initialValues={{}}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ width: "350px" }}>
                  <GridLayout
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                    gap={{ rows: 0 }}
                    cols={[{ width: "100%" }]}
                  >
                    <GridLayoutItem style={{ width: "100%" }}>
                      <Field
                        id={"RequestStatus"}
                        name={"RequestStatus"}
                        component={FormSelectionField}
                        label={"Status"}
                        options={PAYMENT_STATUS_ARRAY?.map((status: any) => {
                          return {
                            value: status.value,
                            label: status.label,
                          };
                        })}
                        astrike={true}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem style={{ width: "100%" }}>
                      <Field
                        name="RequestStatusRemarks"
                        label="Remarks"
                        placeholder="Remarks"
                        rows={2}
                        component={FormTextArea}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      colSpan={1}
                      style={{
                        textAlign: "end",
                        marginTop: "10px",
                        width: "100%",
                      }}
                    >
                      <DialogCloseButton themeColor="primary" />
                      <ButtonWithLoading
                        label={"Update"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

const DeleteTopupRequestDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const TopupRequestID = useAppSelector(
    (state) => state.topuprequest.TopupRequestID
  );
  const loading = useAppSelector((state) => state.topuprequest.loading);

  const TopupRequestFilterDetails = useAppSelector(
    (state) => state.topuprequest.TopupRequestFilterDetails
  );

  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteTopupRequest(ID));
      if (response.payload?.Data?.Status === 200) {
        const payload = {
          ...TopupRequestFilterDetails,
          FromDate: TopupRequestFilterDetails?.FromDate
            ? moment(TopupRequestFilterDetails?.FromDate).format("YYYY-MM-DD")
            : null,
          ToDate: TopupRequestFilterDetails?.ToDate
            ? moment(TopupRequestFilterDetails?.ToDate).format("YYYY-MM-DD")
            : null,
          Limit: +pageLimit,
          Skip: +currentPage * +pageLimit,
        };
        dispatch(getAllTopupRequests(payload));
        dispatch(closeDialog());
        dispatch(clearTopupRequestID());
      } else {
        const payload = {
          ...TopupRequestFilterDetails,
          FromDate: TopupRequestFilterDetails?.FromDate
            ? moment(TopupRequestFilterDetails?.FromDate).format("YYYY-MM-DD")
            : null,
          ToDate: TopupRequestFilterDetails?.ToDate
            ? moment(TopupRequestFilterDetails?.ToDate).format("YYYY-MM-DD")
            : null,
          Limit: +pageLimit,
          Skip: +currentPage * +pageLimit,
        };
        dispatch(getAllTopupRequests(payload));
        dispatch(closeDialog());
        dispatch(clearTopupRequestID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteTopupRequest" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Topup Request?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Topup Request?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(TopupRequestID)}
                  type="button"
                  disabled={loading}
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default TopupRequest;
